"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const v1_1 = require("./v1");
__export(require("./v1"));
exports.faContentServiceDefinition = {
    id: 'fa-content-service',
    create: () => {
        return {
            '1.0.0': () => ({
                featureService: new v1_1.FaContentServiceV1Impl(),
            }),
        };
    },
};
//# sourceMappingURL=index.js.map